<template>
  <v-data-table
    v-bind="this.$attrs"
    v-model="selectedItems"
    loading-text="Đang Tải"
    item-key="id"
    class="mt-3"
    :headers="headers"
    :items="slots"
    :search="search"
    :disable-pagination="true"
    hide-default-footer
  >
    <!-- :server-items-length="count" -->
    <!-- @pagination="pagination" -->
    <!-- :page="page"
    :items-per-page="10" -->
    <template v-slot:top="{ items }">
      <div class="d-flex py-3">
        <span class="text-body-2"> Total: {{ items.length }} </span>
        <div class="flex-fill"></div>
      </div>
    </template>
    <template v-slot:item.category="{ item }">
      {{ renderSlotCategory(item.category) }}
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>{{ item.status | status }}</v-chip>
    </template>
    <template v-slot:item.class.code="{ item }">
      <router-link style="text-decoration: none" :to="'/class/' + item.class.id">{{
        item.class.code
      }}</router-link>
    </template>
    <template v-slot:item.teachers="{ item }">
      <user-item :teacher="item.teachers[0]" :role="role"></user-item>
    </template>
    <template v-slot:item.room="{ item }">
      <span>{{ item.room | getRoom }}</span>
    </template>
    <template v-slot:item.mentors="{ item }">
      <user-item :teacher="item.mentors[0]" :role="role"></user-item>
    </template>
    <template v-slot:item.startTime="{ item }">{{
      $moment(item.startTime).format('HH:mm')
    }}</template>
    <template v-slot:item.startTimeDate="{ item }">{{ item.startTimeDate }}</template>
    <template v-slot:item.type="{ item }">{{ item.type | type }}</template>
    <template v-slot:item.attendances="{ item }" v-if="role.name !== 'Student'">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn
              v-if="['super_admin', 'education_manager', 'teacher'].includes(role.type)"
              :disabled="!isTimeValid(item.startTime)"
              @click="onCheckAttendance(item)"
              icon
            >
              <v-icon>mdi-account-check</v-icon>
            </v-btn></span
          >
        </template>
        <span>{{ attendanceTooltip(item.startTime) }}</span>
      </v-tooltip>
    </template>
    <template
      v-slot:item.actions="{ item }"
      v-if="['education_manager', 'super_admin'].includes(role.type)"
    >
      <slot-list-actions :selected="item" @edit="onEdit" />
    </template>
  </v-data-table>
</template>
<script>
import { renderSlotCategory } from '@/helpers'
import { mapState } from 'vuex'
import moment from 'moment'
import SlotListActions from '@/modules/slot/SlotListActions'
import UserItem from '@/components/basic/card/CardTeacherName'

export default {
  components: {
    UserItem,
    SlotListActions
  },
  props: {
    slots: Array,
    count: Number,
    add: Boolean,
    headers: Array
  },
  data() {
    return {
      page: 1,
      search: '',
      attendanceCheckTime: 24,
      selectedItems: []
    }
  },
  computed: {
    ...mapState('app', ['staffs']),
    ...mapState('auth', ['user', 'role']),
    ...mapState('constant', ['slotStatus', 'slotTypes'])
  },
  methods: {
    // async pagination(page) {
    //   this.$emit('pagination', page)
    // },
    renderSlotCategory(i) {
      return renderSlotCategory(i)
    },
    onEdit(selected) {
      this.$emit('edit', selected)
    },
    onCheckAttendance(item) {
      this.$emit('onCheckAttendance', item)
    },
    getColor(status) {
      if (status === 'opened') return 'orange'
      if (status === 'running') return 'green'
      if (status === 'rejected') return 'red'
      if (status === 'canceled') return 'gray'
      if (status === 'done') return 'gray'
      else return 'orange'
    },
    isTimeValid(startTime) {
      if (this.role.name === 'Teacher') {
        const diffTime = moment.duration(moment().diff(moment(startTime))).asHours()
        return diffTime < this.attendanceCheckTime && diffTime > -1 * this.attendanceCheckTime
      }
      return true
    },
    attendanceTooltip(startTime) {
      if (this.role.name === 'Teacher') {
        const diffTime = moment.duration(moment().diff(moment(startTime))).asHours()
        if (diffTime < -1 * this.attendanceCheckTime) {
          return 'Chưa đến lúc điểm danh'
        }
        if (diffTime > this.attendanceCheckTime) return 'Đã quá hạn điểm danh'
      }
      return 'Bấm vào để điểm danh'
    }
  },
  watch: {
    selectedItems() {
      this.$emit('onSelectionChanged', this.selectedItems)
    }
  },
  filters: {
    status(status) {
      if (status === 'opened') {
        return 'Chờ điểm danh'
      } else if (status === 'running') {
        return 'Đã điểm danh'
      } else if (status === 'done') {
        return 'Hoàn Thành'
      } else if (status === 'rejected') {
        return 'Bị từ chối'
      } else if (status === 'canceled') {
        return 'Đã Hủy'
      } else {
        return 'Chờ điểm danh'
      }
    },
    type(type) {
      if (type === 'class-slot') {
        return 'Lớp Học'
      } else {
        return 'Dạy Bù'
      }
    },
    getRoom(room) {
      if (room) {
        return room.title
      }
    }
  }
}
</script>
